import * as d3 from "d3";
import ZoomAbstract from "./ZoomAbstract";
import ActiveRegion from "../Auxiliar/ActiveRegion";

export default class AutoZoomManager extends ZoomAbstract {
    // Public:
    constructor(cParams) {
        super(cParams);
        this.saveParams(cParams);
    }

    setTimeout(nodes, delayTime) {
        this.clearTimeout();
        let func = () => this.apply(nodes);
        this._timeout = setTimeout(func, delayTime);
        this.addTimeoutToWindow();
    }

    apply(nodes) {
        this._nodes = nodes;
        this.computeActiveRegion();
        this.updateCenter();
        this.computeScale();
        this.applyTransformation();
    }

    setCenter(center) {
        this._center = center;
    }

    // Private:
    saveParams(cParams) {
        this._svg = cParams.svg;
        this._relaxationFactor = cParams.scaleRelaxationFactor;
    }

    computeActiveRegion() {
        const nodes = this._nodes;
        let activeRegion = new ActiveRegion(nodes);
        activeRegion.compute();
        this._activeRegion = activeRegion;
    }

    updateCenter() {
        const activeRegion = this._activeRegion;
        const center = activeRegion.getCenter();
        this.setCenter(center);
    }

    computeScale() {
        const elementId = this._elementId;
        let element = document.getElementById(elementId);
        if (element !== null) {
            const b = this._relaxationFactor;
            const activeRegion = this._activeRegion;
            const a = 1 / b;
            const wA = element.scrollWidth;
            const wB = activeRegion.getWidth();
            const k1 = wA / wB;
            const hA = element.scrollHeight;
            const hB = activeRegion.getHeight();
            const k2 = hA / hB;
            const k = Math.min(1.0, a * k1, a * k2);
            this._scale = k;
        }
    }

    applyTransformation() {
        const elementId = this._elementId;
        let svg = d3.select("#" + elementId).select("svg");
        const scale = this._scale;
        const k = this.makeIdentityIfInvalid(scale);
        const d = this.computeDisplacement();
        let transform = d3.zoomIdentity.scale(k).translate(d.x, d.y);
        let viewBox = this.getNewViewBox(transform);
        svg.transition()
            .duration(1000)
            .delay(0)
            .attr("viewBox", viewBox);
        this.setZoomState(transform);
    }

    computeDisplacement() {
        const scale = this._scale;
        const k = this.makeIdentityIfInvalid(scale);
        const elementId = this._elementId;
        let element = document.getElementById(elementId);
        if (element !== null) {
            const w = element.scrollWidth;
            const h = element.scrollHeight;
            const P1 = this._center;
            // const P1 = {x:0, y:0};
            var dx = -(P1.x - ((1 / k) * w) / 2);
            var dy = -(P1.y - ((1 / k) * h) / 2);
        }
        dx = this.makeZeroIfInvalid(dx);
        dy = this.makeZeroIfInvalid(dy);
        const d = {
            x: dx,
            y: dy,
        };
        return d;
    }

    computeNewDimensions() {
        let P0 = this._P0;
        let P1 = this._P1;
        let w = P1.x - P0.x;
        let h = P1.y - P0.y;
        this._width = w;
        this._height = h;
    }

    clearTimeout() {
        clearTimeout(this._timeout);
    }

    addTimeoutToWindow() {
        const elementId = this._elementId;
        const element = document.getElementById(elementId);
        element.addTimeout(this._timeout);
    }
}
